import { MESApiService } from "@dexteel/mesf-core";

export const getMaterials = async () => {
  const apiService = new MESApiService();
  return await apiService.callV2("[STEEL].[GetMaterials]", []);
};
